import axios from 'axios';

let prefix = "/equipment-rarity"

const EquipmentRarityApi = {
	listEquipmentRarities(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getEquipmentRarity(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	createEquipmentRarity(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateEquipmentRarity(payload) {
		return axios.post(prefix + "/update", payload)
	},
	archiveEquipmentRarity(payload) {
		return axios.delete(prefix + "/archive", { data: payload })
	},
}

export default EquipmentRarityApi;
